import React from "react";
import styled from "styled-components";
import BannerDesktop from "./BannerDesktop";
import DropdownLogout from "./DropdownLogout";
import HeaderMetrics from "./HeaderMetrics";
import { useTransaction } from "../hooks/useTransaction";

const Wrapper = styled.div`
  position: relative;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const DropdownWrap = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
`;

const MetricsWrap = styled.div`
  padding: 0 0 4px;
`;

export default function DesktopPageHeader(props) {
  const { points, pointsLoader } = useTransaction();

  return (
    <Wrapper>
      <BannerDesktop {...props} />
      <DropdownWrap>
        <DropdownLogout color="#ffffff" />
      </DropdownWrap>
      <MetricsWrap>
        <HeaderMetrics
          likes={points?.likes || 0}
          points={points?.points || 0}
          labelLikes={points?.labelLikes || "Puntos"}
          labelPoints={points?.labelPoints || "Ñamis"}
          loaderLikes={pointsLoader}
          loaderPoints={pointsLoader}
        />
      </MetricsWrap>
    </Wrapper>
  );
}
